
// ボタンを無効に
export function invalid(thisElem) {

    $(thisElem).css({
        'pointer-events': 'none',
        'touch-action': 'none',
    });
    $(thisElem).find('.btn_text').css('opacity', '0');
    $(thisElem).find('.spinner').css('opacity', '1');
}

// ボタンを有効に
export function valid(thisElem) {

    $(thisElem).css({
        'pointer-events': 'auto',
        'touch-action': 'auto',
    });
    $(thisElem).find('.spinner').css('opacity', '0');
    $(thisElem).find('.btn_text').css('opacity', '1');
}